import UserList from "../../../../User/components/user-listing/components/index";
import ClientHeader from "../../client-header/components";

const ClientUserList = () => {
    return (
    <div>
        <ClientHeader />
      <UserList />
      
    </div>
  );
};

export default ClientUserList;
